import React, { PropTypes } from 'react';
import moment from 'moment-timezone';
import ImageUploadModal from 'common/components/modal/image_upload_modal';
import Avatar from 'common/components/avatar';

const EditMeta = ({
  avatar, country, country_full_name, user_timezone, first_name, last_name, username, selectAvatar,
  selectedAvatar, showAvatarSelector, toggleSelect, updateAvatar,
}) => {
  const time = user_timezone ? moment().tz(user_timezone).format('h:mm a') : null;

  return (
  <div className="profile-meta">
    <div className="avatar-img-container">
      <Avatar user={{avatar, first_name, last_name, username}} extraClasses="avatar-xl avatar-shadow"/>
      <a className="change-avatar" onClick={toggleSelect}>
        Change
      </a>
    </div>
    <div className="location">
      { country && <span className="country">{ country_full_name }</span> }
    </div>
    { time && <div className="time">{time} local</div> }
    <ImageUploadModal
      minWidth={200}
      minHeight={200}
      show={showAvatarSelector}
      preCrop={selectedAvatar}
      selectImage={selectAvatar}
      onCrop={updateAvatar}
      maxSize={0.5}
      tips={['Use PNG or JPG', 'Square images work best', '200x200 minimum dimensions', '500kb maximum file size']}
      toggleModal={toggleSelect}
    />
  </div>);
};

EditMeta.propTypes = {
  avatar: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  username: PropTypes.string,
  country: PropTypes.string,
  country_full_name: PropTypes.string,
  user_timezone: PropTypes.string,
  selectedAvatar: PropTypes.string,
  selectAvatar: PropTypes.func,
  updateAvatar: PropTypes.func,
  toggleSelect: PropTypes.func,
  showAvatarSelector: PropTypes.bool,
};

export default EditMeta;



// WEBPACK FOOTER //
// ./profile/components/edit_meta.jsx